import Vue from 'vue'
import Card from './common/Card.vue'
import Button from './common/Button.vue'
import Checkbox from './core/Inputs/Checkbox.vue'
import SearchInput from './common/SearchInput.vue'
import Divider from './common/Divider.vue'
import Table from './common/Table.vue'
import Child from './Child.vue'
import { HasError, AlertError, AlertSuccess } from 'vform/components/bootstrap5'
import Pills from '~/components/Pills'
import Star from '~/components/core/ToggleButtons/Star'
import AddBuyerModal from '~/pages/contacts/components/AddBuyerModal'
import CardInfoModal from '~/pages/checkout-proceed/components/CardInfoModal'
import PTabs from '~/components/core/PTabs/PTabs'
import EmailDraftOrderModal from '~/pages/checkout-proceed/components/EmailDraftOrderModal'
import QuantityInput from './QuantityInput.vue'


// Components that are registered globally.
[
  Card,
  Child,
  Button,
  Checkbox,
  SearchInput,
  Divider,
  Table,
  QuantityInput,
  // Modal,
  HasError,
  AlertError,
  AlertSuccess,
  Pills,
  Star,
  PTabs,

  // Modals
  AddBuyerModal,
  CardInfoModal,
  EmailDraftOrderModal
].forEach(Component => {
  Vue.component(Component.name, Component)
})
